import { render, staticRenderFns } from "./Bulletin.vue?vue&type=template&id=5df26f4c&scoped=true"
import script from "./Bulletin.vue?vue&type=script&lang=js"
export * from "./Bulletin.vue?vue&type=script&lang=js"
import style0 from "@/assets/pdf/css/default.less?vue&type=style&index=0&id=5df26f4c&prod&scoped=true&lang=less&external"
import style1 from "./Bulletin.vue?vue&type=style&index=1&id=5df26f4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df26f4c",
  null
  
)

export default component.exports